export default {
    devices_main_id: 'Id',
    devices_main_label: 'Etiqueta',
    devices_main_device_model: 'Modelo del Dispositivo',
    devices_main_status: 'Estado',
    devices_main_company: 'Cuenta',
    devices_main_devices: 'Dispositivos',
    devices_main_advanced_filters: 'Filtros avanzados',
    devices_main_apply: 'Aplicar',
    devices_main_tags: 'Etiquetas',
    devices_main_active_devices_only: 'Sólo dipositivod activos',
    devices_main_yes: 'Si',
    devices_main_no: 'No',
    devices_main_authenticate_cloud: 'Iniciar sesión como cliente',
    devices_main_re_sync_backend_information: 'Re-sincronización de la información del backend',
    devices_main_sim_number: "# de SIM",
    devices_main_serial: "Serial",
    devices_main_sim_provider: "Proveedor de la SIM",
    devices_main_network: "Red",
    devices_main_linked_device_label: "Unidad Emparejada",
    devices_main_linked_device: "Serial de la Unidad GPS",
    devices_main_linked_camera: "Serial de la Cámara",
    devices_main_createdOn: "Creada en",
    devices_main_updatedOn: "Actualizada en",
    devices_main_unitTime: "Fecha de la Unidad",
    devices_main_serverTime: "Fecha del Sevidor",
    devices_main_lastMessageTime: "Fecha del Último Mensaje",
    devices_main_age: "Edad",
    devices_main_edit: "Editar",
    devices_main_manufacturer: "Fabricante",
    devices_main_manufacturers: "Fabricantes",
    devices_main_sim_provider_account: "Cuenta del Proveedor de SIM",
    devices_main_network_type: "Tipo de Red",
    devices_main_bulk_pairing: "Emparejamiento masivo",
    devices_main_bulk_vidfleet_configuration: "Configuración masiva de VidFleet",
    devices_main_bulk_vidfleet_config_device_model: "Solo dispositivos del mismo modelo pueden ser seleccionados",
    devices_main_bulk_vidfleet_config_device_manufacturer: "Acción disposnible solo para dispositivos VidFleet",
    devices_main_bulk_vidfleet_configuration_upload_mode: "Configuración modo de subida masiva de VidFleet",
    devices_main_import_and_assign:"Importar y Asignar",
    devices_main_bulk_actions: "Acciones masivas",
    devices_main_change_sim_provider: "Cambiar de proveedor de SIM",
    devices_main_global_star_error: "Los dispositivos Global Star no disponen de esta acción",
    devices_main_calamp_error: "Solo los dispositivos Calamp estan permitidos",
    devices_main_import_device_result: "Resultado De Los Dispositivos Importados",
    devices_main_assign_firmware: "Asignar el Firmware",
    devices_main_assign_firmware_error_label: "La versión de hardware de los dispositivos debe ser la misma",
    devices_main_device_info: "Información del Dispositivo",
    devices_main_device_raw_data: "Data sin Procesar",
    devices_main_device_commands: "Comandos",
    devices_main_edit_swap_sim_card: "Editar e intercambiar la tarjeta SIM",
    devices_main_smartWitness_error: "Los dispositivos SmartWitness no pueden ser editados o seleccionados para la acción",
    devices_main_only_vidfleet: "El fabricante de los dispositivos debe ser VidFleet",
    devices_main_send_command: "Enviar comando",
    devices_main_the_manufacturer_of_the_devices_must_be_the_same: "El fabricante de los dispositivos debe ser el mismo",
    devices_main_the_manufacturer_of_the_devices_must_be_different_from_vidfleet: "El fabricante de los dispositivos debe ser diferente de VidFleet",
    devices_main_general_info: "Información General",
    devices_main_firmware: "Firmware",
    devices_main_mark_as_rma: "Marcar como RMA",
    devices_main_only_vidfleet_and_smartwitness: "El fabricante de los dispositivos debe ser VidFleet o SmartWitness",
    devices_main_mode: "Modo",
    devices_main_show_in_web: "Mostrar en la Web",
    devices_main_reference: "Referencia",
    devices_main_show_last_reading_info: "Mostrar información de la última lectura",
    devices_main_revert_rma: "Revertir RMA",
    devices_main_mass_sms: "SMS Masivo",
    devices_main_puls_group: "Grupo",
    devices_main_same_manufacturer_device_model: "El fabricante y el modelo de los dispositivos debe ser el mismo",
    devices_main_select_devices: "Por favor seleccione los dipositivos primero",
    devices_main_bulk_features: "Cambiar Propiedades Masivamente",
    devices_main_camera_actions: "Acciones de la cámara",
    devices_main_change: "Cambiar",
    devices_main_commands: "Comandos",
    devices_main_brand: "Marca",
    devices_main_warning_message_calamp_api: "Los dispositivos seleccionados deben ser de la misma api de Calamp",

    devices_main_all: "Todos",
    devices_main_esn: "ESN",
    devices_main_imei: "IMEI",
    devices_main_iccid: "ICCID",
    devices_main_company: "Compañia",
    devices_main_label: "Etiqueta",
    devices_main_reference: "Referencia",
    devices_main_hardware_version: "Versión del Hardware",
    devices_main_installed: "Instalado",
    devices_main_pending_installed: "Instalación Pendiente",
    devices_main_installed_on: "Fecha Instalación",
    devices_main_installed_only: "Solo Instalados",
    devices_main_coverage_score: "Puntaje de Diagnóstico",
    devices_main_coverage_updated_on: "Actualización Diagnóstico",
    devices_main_create_diagnostic_device: "Crear Diagnóstico",
    devices_main_maintenance_warnings: "Advertencias",
    devices_main_maintenance_warnings_label: "Sólo con advertencias de mantenimiento",
    devices_main_maintenance_health_score: "Puntuacion/Salud",
    devices_main_live_mode: "Modo de transmisión",
    devices_main_live_mode_straming: "Video",
    devices_main_live_mode_photo: "Foto",
    devices_main_only_att: "Solo se permiten cámaras con proveedor de SIM AT&T",
    devices_main_vin: "VIN",
    devices_main_phone_number: "Número de Teléfono",
    devices_main_battery_level: "Nivel de Batería",
    devices_main_vin: "VIN",
    devices_main_id: "Id",
    devices_main_sd_card_error: "Error de tarjeta SD",
    devices_main_live_streaming: "Transmisión en vivo",
    devices_main_offline: "Fuera de línea",
    devices_main_last_event: "Último evento",
    devices_main_bulk_tags: "Etiquetas Masivas",
    devices_main_billing_account: "Cuenta de Facturación",
    devices_main_address: "Dirección",
    devices_main_assign_unassign_billing_account: "Asignar/Desasignar Cuenta de Facturación",
    devices_main_different_brands: "Los dispositivos deben ser de la misma marca para asignar o desasignar la cuenta de facturación",
    devices_main_unit_type: "Tipo de Unidad",

};